import React from 'react';

/** Loading skeleton — 6 shimmering cards matching the final layout. */
export default function CommandCenterSkeleton() {
  return (
    <div className="cc-grid" data-testid="cc-skeleton" aria-hidden="true">
      {Array.from({ length: 6 }).map((_, i) => (
        <div key={i} className="cc-skeleton-card" />
      ))}
    </div>
  );
}
